import { render, staticRenderFns } from "./resource-link.vue?vue&type=template&id=ae6042aa"
import script from "./resource-link.vue?vue&type=script&lang=ts"
export * from "./resource-link.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports